import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BRAND } from "@/components/Brand";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Token ausente");
    if (pwd.length < 4) return toast.error("Senha muito curta");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("Senha redefinida! Faça login.");
      nav("/login");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Token inválido ou expirado");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="reset-form">
        <div className="flex flex-col items-center mb-2">
          <img src={BRAND.logo} alt="" className="w-16 h-16 object-contain"/>
          <div className="font-display font-bold text-lg mt-2">
            <span>Gestão </span>
            <span style={{ background: "linear-gradient(90deg, #4F46E5, #A855F7)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>Expert</span>
          </div>
        </div>
        <div>
          <p className="label-tiny mb-2">Acesso</p>
          <h1 className="font-display text-3xl tracking-tight">Redefinir senha</h1>
          <p className="text-sm text-neutral-500 mt-2">Defina uma nova senha para entrar.</p>
        </div>
        <div>
          <Label>Nova senha</Label>
          <Input type="password" value={pwd} onChange={e=>setPwd(e.target.value)} required data-testid="reset-password-input"/>
        </div>
        <Button type="submit" disabled={busy} className="w-full bg-[#0A0A0A] hover:bg-black text-white" data-testid="reset-submit">
          {busy ? "Salvando…" : "Redefinir"}
        </Button>
        <div className="text-center text-xs text-neutral-500"><Link to="/login" className="underline">Voltar ao login</Link></div>
      </form>
    </div>
  );
}
